module.exports = __webpack_public_path__ + "static/media/road.62d48a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/road.png
// module id = 67
// module chunks = 0